// ----------------------------- 楼层类型 -----------------------------

export const FLOOR_TYPE_NAVIGATION = 'NAVIGATION_WIDGET';
export const FLOOR_TYPE_HEAD = 'HEAD_WIDGET';
export const FLOOR_TYPE_MAIN = 'MAIN_WIDGET';
export const FLOOR_TYPE_BANNER = 'BANNER_WIDGET';
export const FLOOR_TYPE_BRAND = 'BRAND_FLOOR';
export const FLOOR_TYPE_ACTIVATE = 'ACTIVATE_WIDGET';
export const FLOOR_TYPE_FOOTER = 'TAIL_WIDGET';
